<template>
  <div class="account-list">
    <h2>账户列表</h2>
    <div class="total-profit-container">
      <span class="total-profit-label">总收益：</span>
      <span class="total-profit-value">{{ totalProfit }}元</span>
    </div>
    <table>
      <thead>
        <tr>
          <th>账户ID</th>
          <th>账户名称</th>
          <th>已收益</th>
          <th>待收益</th>
          <th>今日任务状态</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="account in accounts" :key="account.account_id" @click="goToDetail(account.account_id)" class="clickable-row">
          <td>{{ account.account_id }}</td>
          <td>{{ account.account_name }}</td>
          <td>{{ account.total_completed_profit}}元</td>
          <td>{{ account.current_amount }}元</td>
          <td :class="{
            'status-completed': account.daily_task_status === '已完成',
            'status-uncompleted': account.daily_task_status === '未完成'
          }">{{ account.daily_task_status || '--' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import apiService from '../services/api.js'

export default {
  name: 'AccountList',
  data() {
    return {
      accounts: [],
      totalProfit: 0
    }
  },
  methods: {
    goToDetail(accountId) {
      const account = this.accounts.find(a => a.account_id === accountId)
      this.$router.push({
        path: `/account/${accountId}/tasks`,
        query: { accountName: account.account_name }
      })
    },
    calculateTotalProfit() {
      this.totalProfit = this.accounts.reduce((sum, account) => {
        // 确保total_completed_profit是数字
        const profit = parseFloat(account.total_completed_profit) || 0
        return sum + profit
      }, 0)
      // 保留两位小数
      this.totalProfit = this.totalProfit.toFixed(2)
    }
  },
  async created() {
    try {
      const response = await apiService.getAccountsList()
      this.accounts = response.data
      this.calculateTotalProfit()
    } catch (error) {
      console.error('获取账户数据失败:', error)
    }
  }
}
</script>

<style scoped>
.account-list {
  margin: 30px auto;
  max-width: 900px;
  padding: 0 20px;
}

h2 {
  color: #2c3e50;
  font-size: 24px;
  margin-bottom: 25px;
  font-weight: 600;
}

table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  margin-top: 20px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

th, td {
  padding: 12px;
  text-align: center;
  border-bottom: 1px solid #ddd;
}

th {
  background: linear-gradient(180deg, #f1f5f9, #e2e8f0);
  font-weight: 700;
  color: #334155;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.clickable-row {
  cursor: pointer;
  transition: all 0.3s ease;
}

.clickable-row:hover {
  background-color: #f1f5f9;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

td {
  color: #334155;
  font-size: 14px;
}

tr:last-child td {
  border-bottom: none;
}

.status-completed {
  color: #10b981;
  font-weight: 600;
}

.status-uncompleted {
  color: #ef4444;
  font-weight: 600;
}

.total-profit-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: -20px;
  margin-bottom: -10px;
  padding: 10px 15px;
  /* background-color: #f8fafc;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05); */
}

.total-profit-label {
  font-size: 16px;
  font-weight: 600;
  color: #475569;
  margin-right: 10px;
}

.total-profit-value {
  font-size: 18px;
  font-weight: 700;
  color: #10b981;
}
</style>
